// Reusable constants

// Components
export const CLOSE_BOTTOM_SHEET = 'close-bottom-sheet';

// Buttons
export const UPDATE_PENSIONSINFO_BUTTON = 'update-pensionsinfo-button';
export const GET_PENSIONSINFO_BUTTON = 'get-pensionsinfo-button';
